import React, { FC, Fragment } from 'react';
import styled from 'styled-components';
import { Product, ProductCategory } from '../../interfaces/Product';
import {
  Wrapper,
  Headline,
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
} from './AdditionalListContentUI';
import { Checkbox } from '../general/forms/Checkbox';
import { UserProductPermissionProps } from '../forms/UserForm';


export interface ProductWithPermission extends Product {
  permissions: UserProductPermissionProps;
}

export interface AdditionalUserProductPermissionsListContentProps {
  category: ProductCategory;
  togglePermission: (payload: UserProductPermissionProps) => void;
  toggleAllLeads: () => void;
  toggleAllContracts: () => void;
  toggleAllSampleContracts: () => void;
}

const ContentRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 1rem 0;
`;

const ToggleAllButton = styled.button`
  border: none;
  background-color: transparent;
  text-decoration: underline;
  text-align: start;
  padding: 0;
  
  :hover {
    @media (pointer: fine) {
      text-decoration: none;
    }
  }
`;

export const AdditionalUserProductPermissionsListContent: FC<AdditionalUserProductPermissionsListContentProps> = (props) => {
  const { category, togglePermission, toggleAllContracts, toggleAllLeads, toggleAllSampleContracts } = props;

  return (
    <Wrapper>
      <ContentRow>
        <div/>
        <ToggleAllButton onClick={toggleAllLeads}>alle an/abwählen</ToggleAllButton>
        <ToggleAllButton onClick={toggleAllSampleContracts}>alle an/abwählen</ToggleAllButton>
        <ToggleAllButton onClick={toggleAllContracts}>alle an/abwählen</ToggleAllButton>
      </ContentRow>

      <AdditionalItemDivider/>

      {
        category?.products?.length > 0 ? (
          <DataWrapper>
            {category.products.map((product: any, index) => (
              <Fragment
                key={index}>
                <ContentRow>
                  <Headline>{product.name}</Headline>
                  <div>
                    <Checkbox
                      checked={product?.permissions?.hasLeadPermission || false}
                      id={'has-lead-permission'}
                      onChange={(checked) => {
                        const payload = product.permissions;
                        payload.hasLeadPermission = checked;
                        togglePermission(payload);
                      }}/>
                  </div>
                  <div>
                    <Checkbox
                      checked={product?.permissions?.hasSampleContractPermission || false}
                      id={'has-sample-contract-permission'}
                      onChange={(checked) => {
                        const payload = product.permissions;
                        payload.hasSampleContractPermission = checked;
                        togglePermission(payload);
                      }}/>
                  </div>
                  <div>
                    <Checkbox
                      checked={product?.permissions?.hasContractPermission || false}
                      id={'has-contract-permission'}
                      onChange={(checked) => {
                        const payload = product.permissions;
                        payload.hasContractPermission = checked;
                        togglePermission(payload);
                      }}/>
                  </div>
                </ContentRow>
                {!(index + 1 === category.products.length) && <AdditionalItemDivider/>}
              </Fragment>
            ))}
          </DataWrapper>
        ) : <DataRow>Fehler</DataRow>
      }
    </Wrapper>
  );
};
